/**
 * SecurityPanel
 */

//React
import React, { useContext, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';

// UI
import {
  createStyles,
  makeStyles,
  Theme,
  createTheme,
} from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  ListItem,
  Collapse,
  ListItemIcon,
  ListItemText,
  Drawer,
  Divider,
  List,
  Avatar,
  DialogTitle,
  DialogActions,
  Dialog,
  Button,
  IconButton,
  Container,
  Box,
  Grid,
  Typography,
  AppBar,
} from '@material-ui/core';

import { TabPanel } from '@material-ui/lab';
// Icon
import Icon from '@mdi/react';
import {
  mdiExitToApp,
  mdiPackageVariant,
  mdiPackageVariantClosed,
  mdiClipboardArrowLeftOutline,
  mdiChevronDown,
  mdiChevronUp,
  mdiCar,
  mdiMenu,
  mdiChevronRight,
  mdiAccountMultipleOutline,
  mdiHandshake,
  mdiWarehouse,
  mdiClose,
  mdiCounter,
  mdiMapMarkerRadiusOutline,
  mdiArchive,
  mdiArchiveOutline,
  mdiClipboardArrowUpOutline,
  mdiAccountSupervisor,
  mdiWeb,
  mdiClipboardListOutline,
  mdiHistory,
  mdiStarBoxMultipleOutline,
  mdiAccountTie,
  mdiAccountMultiple,
  mdiHome,
} from '@mdi/js';
// Component
import Can from '../../components/Can';
import AuthContext from '../../authContext';

// Type
import { MenuInterface, Menus } from './interfaces';

import windowSize from '../../utils/hook/useWindowResize';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textStyle: {
      textDecorationColor: '#2f4858',
    },
    exitButton: {
      color: '#2f4858',
      position: 'fixed',
      bottom: '0',
    },
    simpleLink: {
      textDecoration: 'none',
      color: 'inherit',
      alignContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '52px',
      right: '0',
      borderBottom: '1',
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',
    },

    routeCard: {
      backgroundColor: '#ffffff',
      borderStyle: 'groove',
      display: 'flex',
      flexBasis: 'content',
      border: '1px solid #E4E4E4',
    },
    iconLabel: {
      textAlign: 'center',
      fontSize: '16px',
      color: '#2f4858!important' as any,
    },
    iconRoutes: {
      padding: '8px',
      borderRadius: '0',
      minWidth: '50vw',
      color: '#2f4858',
    },
    iconButtonBackground: {
      backgroundColor: '#fff',
    },
    topText: {
      color: '#2f4858',
      fontSize: '16px',
    },
    icon: {
      color: '#fff',
    },
    toggleHolder: {
      height: '129px',
    },

    hideList: {
      display: 'none',
    },
    activePro: {
      '&:hover': {
        backgroundColor: '#DFA02E  !important',
      },
      textDecoration: 'none',
      backgroundColor: '#DFA02E',
    },
    item: {
      color: 'inherit',
      textDecoration: 'none',
    },
    sidebar: {
      // position: 'relative',
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      '@media (max-width: 768px)': {
        position: 'fixed',
        transform: 'translate(-100%, -100%)',
        zIndex: '9',
      },
    },
    sidebarOpenMob: {
      '@media (max-width: 768px)': {
        transform: 'none',
      },
    },
    sidebarCloseMob: {
      '@media (max-width: 768px)': {
        transform: 'translate(-100%, -100%)',
      },
    },
    drawer: {
      marginTop: '40px',
      marginBottom: '70px',
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      // overflowX: 'hidden',
      overflow: 'visible',
      background: theme.palette.primary.main,
      color: '#fff',
      // transition: theme.transitions.create('width', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    drawerClose: {
      // transition: theme.transitions.create('width', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),

      marginBottom: '7px',
      overflowX: 'hidden',
      // overflow: 'visible',
      width: theme.spacing(8) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
      background: theme.palette.primary.main,
      color: '#fff',
    },
    appBar: {
      padding: '12px',
      backgroundColor: '#ffffff',
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },

    nested: {
      '& > span': {
        paddingLeft: theme.spacing(7),
        fontSize: '14px !important',
      },
    },
    avatar: {
      margin: theme.spacing(6, 'auto', 7),
      height: '70px !important',
      // transition: theme.transitions.create('all', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    avatarLarg: {
      width: '148px',
      height: theme.spacing(15),
    },

    avatarSmall: {
      // marginTop: '54px',
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    avatarMob: {
      // marginTop: '54px',
      width: theme.spacing(0),
      height: theme.spacing(0),
    },
    userInfoContainer: {
      marginTop: 'auto',
      alignItems: 'center',
    },
    userInfoBox: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px',
      marginRight: '5px',
    },
    userInfoIconBox: {
      backgroundColor: '#345163',
      borderRadius: '4px',
      display: 'flex',
      // marginLeft: '5px',
    },
    userAvatar: {
      backgroundColor: '#345163',
      width: '43px',
      height: '43px',
    },
    username: {
      padding: theme.spacing(0, 1),
      fontSize: '16px',
      fontWeight: 500,
    },
    toolbar: {
      display: 'flex',
      position: 'relative',
      top: 0,
      backgroundColor: theme.palette.primary.main,
      // backgroundColor: 'red',
      zIndex: 20,

      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    toolbarOpen: {
      width: drawerWidth,
      alignItems: 'flex-start',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // transition: 'all .2s',
    },
    toolbarClose: {
      width: '73px',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toolbarCircle: {
      textAlign: 'center',
      display: 'flex',
      backgroundColor: theme.palette.background.default,
      borderRadius: '50%',
      width: '100%',
      height: '100%',
    },
    toolbarCircleSecound: {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      margin: 'auto',
      '@media (max-width: 768px)': {},
    },
    divider: {
      backgroundColor: '#fff',
      margin: '0 16px',
    },
    mobMenu: {
      display: 'none',
      '@media (max-width: 768px)': {
        position: 'fixed',
        top: '0',
        right: '0',
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '64px',
        backgroundColor: theme.palette.primary.main,
        padding: '20px',
        zIndex: '10',
      },
    },
  })
);

// Const
const drawerWidth = 231;

export default function SecurityPanel(props: any) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);

  const exitHandler = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('partnerId');
    localStorage.removeItem('warehouseId');
    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    window.location.href = '/login';
  };

  //Important: exitHandler should not be bound to click
  //confirmation modal should be brought up before that
  return (
    <div>
      <AppBar className={classes.appBar}>
        <Typography className={classes.topText} variant="h6">
          پنل حراست
        </Typography>
      </AppBar>

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
      >
        <Grid item xs={6} direction="column" className={classes.routeCard}>
          <Link className={classes.simpleLink} to="/security/active-drivers?filter=ORDER">
            <IconButton className={classes.iconRoutes}>
              <Icon path={mdiAccountMultiple} size={3} />
            </IconButton>
            <p className={classes.iconLabel}>سفارش ها</p>
          </Link>
        </Grid>
        <Divider />
        <Grid item xs={6} direction="column" className={classes.routeCard}>
          <Link className={classes.simpleLink} to="/security/traffic-history?filter=ORDER">
            <IconButton className={classes.iconRoutes}>
              <Icon path={mdiCar} size={3} />
            </IconButton>
            <p className={classes.iconLabel}>تاریخچه ورود و خروج سفارش</p>
          </Link>
        </Grid>
        <Grid item xs={6} direction="column" className={classes.routeCard}>
          <Link className={classes.simpleLink} to="/security/active-drivers?filter=PARCEL">
            <IconButton className={classes.iconRoutes}>
              <Icon path={mdiAccountMultiple} size={3} />
            </IconButton>
            <p className={classes.iconLabel}>محموله ها</p>
          </Link>
        </Grid>
        <Divider />
        <Grid item xs={6} direction="column" className={classes.routeCard}>
          <Link className={classes.simpleLink} to="/security/traffic-history?filter=PARCEL">
            <IconButton className={classes.iconRoutes}>
              <Icon path={mdiCar} size={3} />
            </IconButton>
            <p className={classes.iconLabel}>تاریخچه ورود و خروج محموله</p>
          </Link>
        </Grid>
      </Grid>

      <Grid container>
        <IconButton onClick={exitHandler} className={classes.exitButton}>
          <Icon path={mdiExitToApp} size={1} />
          <p className={classes.iconLabel}>خروج</p>
        </IconButton>
      </Grid>
    </div>
  );
}
